import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useTestByEnvironment } from '@/hooks/discovery/test';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useTest = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { userId } = useEnvironmentScope();
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;

  const [{ fetching, error, data }] = useTestByEnvironment({
    environmentId: validEnvironmentId,
    userId: userId as number | null,
    uniqueId: uniqueId?.raw ?? '',
    pause:
      (uniqueId?.resourceType !== 'test' && uniqueId?.resourceType !== 'unit_test') ||
      userId === 'loading',
  });

  const testQuery = useMemo(() => {
    const appliedEdge = data?.environment.applied?.tests.edges?.[0];
    return {
      fetching,
      error,
      data: { applied: appliedEdge?.node },
    };
  }, [fetching, error, data]);

  return testQuery;
};
